import React, { useState } from 'react';
import {
  IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButtons,
  IonBackButton, IonButton, IonSpinner,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { useCreateCashTransaction } from '../hooks/useCash';

const labelStyle: React.CSSProperties = {
  display: 'block', marginBottom: 4, fontSize: 14,
  fontWeight: 600, color: 'var(--ion-color-medium)',
};

const inputStyle: React.CSSProperties = {
  width: '100%', padding: '10px 12px', fontSize: 16,
  border: '1px solid var(--ion-color-medium)', borderRadius: 8,
  background: 'var(--ion-item-background, #fff)',
  color: 'var(--ion-text-color)',
  boxSizing: 'border-box',
};

const selectStyle: React.CSSProperties = { ...inputStyle, appearance: 'auto' as any };

const fieldGroup: React.CSSProperties = { marginBottom: 12 };

const CashTransactionForm: React.FC = () => {
  const history = useHistory();
  const createTransaction = useCreateCashTransaction();

  const [form, setForm] = useState({
    transaction_type: 'deposit' as 'deposit' | 'withdrawal',
    amount: '' as string | number,
    notes: '',
  });

  const handleSubmit = async () => {
    await createTransaction.mutateAsync({
      transaction_type: form.transaction_type,
      amount: Number(form.amount),
      notes: form.notes || undefined,
    });
    history.goBack();
  };

  const isValid = form.amount !== '' && Number(form.amount) > 0;

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonBackButton defaultHref="/history" />
          </IonButtons>
          <IonTitle>Cash Transaction</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <div style={{ maxWidth: 500, margin: '0 auto' }}>
          {/* Transaction Type */}
          <div style={fieldGroup}>
            <label style={labelStyle}>Transaction Type *</label>
            <select
              style={selectStyle}
              value={form.transaction_type}
              onChange={(e) => setForm((f) => ({ ...f, transaction_type: e.target.value as any }))}
            >
              <option value="deposit">Deposit (Add Funds)</option>
              <option value="withdrawal">Withdrawal (Remove Funds)</option>
            </select>
          </div>

          {/* Amount */}
          <div style={fieldGroup}>
            <label style={labelStyle}>Amount ($) *</label>
            <input
              style={inputStyle}
              type="number"
              step="0.01"
              min="0.01"
              value={form.amount}
              onChange={(e) => setForm((f) => ({ ...f, amount: e.target.value }))}
              placeholder="0.00"
            />
          </div>

          {/* Notes */}
          <div style={fieldGroup}>
            <label style={labelStyle}>Notes</label>
            <textarea
              style={{ ...inputStyle, resize: 'vertical', minHeight: 80, fontFamily: 'inherit' }}
              value={form.notes}
              onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
              placeholder="Optional notes about this transaction"
            />
          </div>

          <IonButton
            expand="block"
            onClick={handleSubmit}
            disabled={!isValid || createTransaction.isPending}
            style={{ marginTop: 16, marginBottom: 16 }}
          >
            {createTransaction.isPending ? <IonSpinner name="crescent" /> : 'Record Transaction'}
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default CashTransactionForm;
